import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_u8merz42xh: FaireBrandEntity = {
  token: "b_u8merz42xh",
  type: "brand",
  name: "Rat City Sk8 Shop",
  avatarUrl:
    "https://cdn.faire.com/fastly/e58783edff72b8186ba74436692d28402ccccd7ac8282437c712847e62b98adb.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2004eb595c14a93d439621db68f5d67d972ffd682867cdafc76f41d393a7733b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e58783edff72b8186ba74436692d28402ccccd7ac8282437c712847e62b98adb.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2004eb595c14a93d439621db68f5d67d972ffd682867cdafc76f41d393a7733b.jpeg",
  location: "tujunga, CA, USA",
  minimumOrderDollars: 416,
  rating: 4.7,
  reviewCount: 15,
  isInsider: true,
  description:
    "Welcome to Rat City Sk8 Shop, where style meets performance in every product we offer. As a proud Faire wholesale account holder, we bring some of the finest selections in the world of skateboarding, streetwear, and urban fashion. At Rat City Sk8 Shop, we go beyond just selling products; we curate experiences. Our shelves are adorned with the latest New Era hats, combining timeless style with modern trends. Whether you're looking for a bold statement piece or a laid-back classic, we've got you covered. But that's not all - our range extends to top-of-the-line shoes that are designed to elevate your skate game. Whether you're hitting the streets or the skate park, our shoes deliver the perfect blend of comfort, durability, and style. And of course, we can't forget our impressive lineup of skate products. From decks to trucks, wheels to bearings, we offer everything a skater needs to stay on top of their game. Our products are not just about functionality; they're about pushing boundaries and unleashing your full potential on the board. So, whether you're a seasoned skater looking to refresh your gear or a newcomer eager to dive into the world of skate culture, Rat City Skate Shop is your go-to destination. Join us on this exhilarating ride as we blend fashion, performance, and passion in every product we offer. ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:56.565Z",
    importedBy: "entity-db-cli",
  },
};
